import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth';
import Layout from './components/Layout';
import Login from './pages/Login';
import Home from './pages/Home';
import Uptime from './pages/Uptime';
import Devices from './pages/Devices';
import Users from './pages/Users';
import Health from './pages/Health';
import LiveView from './pages/LiveView';

function Guard({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="login-page muted">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          element={
            <Guard>
              <Layout />
            </Guard>
          }
        >
          <Route path="/" element={<Home />} />
          <Route path="/uptime" element={<Uptime />} />
          <Route path="/health" element={<Health />} />
          <Route path="/live" element={<LiveView />} />
          <Route path="/devices" element={<Devices />} />
          <Route
            path="/users"
            element={
              <Guard role="admin">
                <Users />
              </Guard>
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
